import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nav__inner container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "nav__links",
  "aria-label": "Primary"
}
const _hoisted_4 = { class: "nav__actions" }
const _hoisted_5 = ["aria-expanded", "aria-label"]
const _hoisted_6 = {
  class: "menu__links container",
  "aria-label": "Mobile"
}
const _hoisted_7 = { class: "menu__footer container" }

import { nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import icon from "@/assets/allading-icon.png";
import StoreButtons from "./StoreButtons.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SiteNav',
  props: {
    solid: { type: Boolean, default: false }
  },
  setup(__props: any) {



const links = [
  { label: "Features", to: { path: "/", hash: "#features" } },
  { label: "Security", to: { path: "/", hash: "#security" } },
  { label: "FAQ", to: { path: "/", hash: "#faq" } },
  { label: "Privacy & terms", to: { path: "/legal" } },
];

const scrolled = ref(false);
const menuOpen = ref(false);
const header = ref<HTMLElement>();
const toggle = ref<HTMLButtonElement>();
const menu = ref<HTMLElement>();

function onScroll() {
  scrolled.value = window.scrollY > 24;
}

function onKey(e: KeyboardEvent) {
  if (e.key === "Escape") menuOpen.value = false;
}

function closeMenu() {
  menuOpen.value = false;
}

// While the menu is open, page content behind it is inert so focus stays in the menu.
function setBackgroundInert(inert: boolean) {
  const siblings = header.value?.parentElement?.children ?? [];
  for (const el of Array.from(siblings)) {
    if (el !== header.value) el.toggleAttribute("inert", inert);
  }
}

watch(menuOpen, async (open) => {
  document.documentElement.style.overflow = open ? "hidden" : "";
  setBackgroundInert(open);
  await nextTick();
  if (open) menu.value?.querySelector<HTMLElement>("a")?.focus();
  else if (document.activeElement === document.body) toggle.value?.focus();
});

onMounted(() => {
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("keydown", onKey);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
  window.removeEventListener("keydown", onKey);
  document.documentElement.style.overflow = "";
  setBackgroundInert(false);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("a", {
      href: "#main",
      class: "skip-link"
    }, "Skip to content", -1)),
    _createElementVNode("header", {
      ref_key: "header",
      ref: header,
      class: _normalizeClass(["nav", { 'nav--solid': __props.solid || scrolled.value, 'nav--open': menuOpen.value }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "nav__brand",
          "aria-label": "Allading home",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(icon),
              alt: "",
              class: "nav__logo",
              width: "28",
              height: "28"
            }, null, 8, _hoisted_2),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "nav__name" }, "Allading", -1))
          ]),
          _: 1
        }),
        _createElementVNode("nav", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link) => {
            return _createVNode(_component_router_link, {
              key: link.label,
              to: link.to
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.label), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { path: '/', hash: '#download' },
            class: "nav__cta"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Download", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("button", {
            ref_key: "toggle",
            ref: toggle,
            type: "button",
            class: "nav__toggle",
            "aria-expanded": menuOpen.value,
            "aria-controls": "mobile-menu",
            "aria-label": menuOpen.value ? 'Close menu' : 'Open menu',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (menuOpen.value = !menuOpen.value))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "nav__toggle-line" }, null, -1),
            _createElementVNode("span", { class: "nav__toggle-line" }, null, -1)
          ]))], 8, _hoisted_5)
        ])
      ]),
      _createVNode(_Transition, { name: "menu" }, {
        default: _withCtx(() => [
          (menuOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: "mobile-menu",
                ref_key: "menu",
                ref: menu,
                class: "menu"
              }, [
                _createElementVNode("nav", _hoisted_6, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link) => {
                    return _createVNode(_component_router_link, {
                      key: link.label,
                      to: link.to,
                      onClick: closeMenu
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  }), 64)),
                  _createVNode(_component_router_link, {
                    to: { path: '/', hash: '#download' },
                    onClick: closeMenu
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Download", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(StoreButtons, { tone: "dark" })
                ])
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2)
  ], 64))
}
}

})